import React from 'react';
import {IPageLink} from '@wix/wixstores-client-core/dist/es/src/types/wix-sdk';
import {IPropsInjectedByViewerScript} from '../../../types/app-types';
import {useIsAfterHydration} from '../hooks/useIsAfterHydration';
import styles from '../Navigation.scss';
import cx from 'classnames';

export interface BreadcrumbsProps {
  path: Breadcrumb[];
  useHref: boolean;
  navigateToLink: IPropsInjectedByViewerScript['navigateToLink'];
  isBreadcrumbsDesignEnabled: boolean;
}

export const enum BreadcrumbsDataHook {
  Root = 'breadcrumbs',
}

export interface Breadcrumb {
  name: string;
  url: string;
  relativeUrl?: string;
  sdkLink: IPageLink;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  path,
  useHref,
  navigateToLink,
  isBreadcrumbsDesignEnabled,
}: BreadcrumbsProps) => {
  const {isAfterHydration} = useIsAfterHydration();

  return (
    <div data-hook={BreadcrumbsDataHook.Root}>
      {isAfterHydration &&
        path.map((link, i) => (
          <React.Fragment key={`crumb-${link.name}-${link.url}`}>
            {i > 0 ? ' / ' : ''}
            <a
              href={useHref ? link.url : null}
              className={cx({[styles.historicalBreadcrumbs]: isBreadcrumbsDesignEnabled})}
              onClick={/* istanbul ignore next */ () => link.url && navigateToLink(link)}
              aria-disabled={!link.url}>
              {link.name}
            </a>
          </React.Fragment>
        ))}
    </div>
  );
};
